export function sleep(duration: number) {
    return new Promise((r) => setTimeout(r, duration));
}

//@NOTE(Lejun) Basically wait for x ms in hopes that the connections in blueprint are dranw
export function waitForBlueprintConnections(duration: number = 600) {
    return sleep(duration);
}
